"use strict";
import { useSectionsForSearchResults } from "appGraphql/data/ring/SearchRingWeb";
import { memo, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { NoResultsFound } from "uniswap/src/components/lists/NoResultsFound";
import { Chain } from "uniswap/src/data/graphql/uniswap-data-api/__generated__/types-and-hooks";
import { SearchModalList } from "uniswap/src/features/search/SearchModal/SearchModalList";
function _SearchModalResultsList({
  chainFilter,
  searchFilter,
  debouncedSearchFilter,
  debouncedParsedSearchFilter,
  activeTab,
  onSelect
}) {
  const { t } = useTranslation();
  const {
    data: sections,
    loading,
    error,
    refetch
  } = useSectionsForSearchResults(Chain.Ethereum, debouncedParsedSearchFilter ?? debouncedSearchFilter, activeTab);
  const userIsTyping = Boolean(searchFilter && debouncedSearchFilter !== searchFilter);
  const emptyElement = useMemo(
    () => debouncedSearchFilter ? <NoResultsFound searchFilter={debouncedSearchFilter} /> : void 0,
    [debouncedSearchFilter]
  );
  return <SearchModalList
    emptyElement={emptyElement}
    errorText={t("token.selector.search.error")}
    hasError={Boolean(error)}
    loading={userIsTyping || loading}
    refetch={refetch}
    sections={sections}
    searchFilters={{
      query: debouncedParsedSearchFilter ?? debouncedSearchFilter ?? void 0,
      searchChainFilter: chainFilter,
      searchTabFilter: activeTab
    }}
    onSelect={onSelect}
  />;
}
export const SearchModalResultsList = memo(_SearchModalResultsList);
